import React from "react";

const Gift = ({ title, description, img, img_url, gift, bg_color, text_color, div1_color, button_bg, btn_hover_bg, btn_active_bg, onClick }) => {
    return (
        <div style={{ backgroundColor: `${bg_color}`, color: `${text_color}` }} className={`bg-[${bg_color}] text-[${text_color}] flex lg:flex-col xs:flex-row flex-col justify-between gap-2`}>
            <div style={{ backgroundColor: `${div1_color}` }} className={`bg-[${div1_color}] h-[80%] xs:h-[100%] lg:h-[50%] w-[100%] xs:w-[50%] lg:w-[100%]
         rounded-2xl p-5 overflow-hidden relative`}>
                <div className="h-full w-full flex flex-col xs:flex-col lg:flex-row xs:justify-between text-left gap-4">
                    <span className="font-[500] text-[24px] xs:text-[28px] lg:text-[28px] mb-2 xs:w-[75%] lg:w-[60%]">{title}</span>
                    <span className="text-[14px] mb-4 lg:w-[40%] xs:w-[35%]">{description}</span>
                </div>
                <div
                    style={{ backgroundImage: `url(${img_url})` }} className={`absolute inset-0 left-1/2 transform -translate-x-1/2 lg:left-[65%] top-[40%] lg:top-[25%] xs:left-[95%] xs:top-[20%] bg-contain lg:h-[300px] lg:w-[300px] xs:h-[350px] xs:w-[350px] w-[400px] h-[400px] bg-no-repeat`}>

                </div>
            </div>
            <div className="h-[15%] xs:h-[100%] lg:h-[50%] w-[100%] xs:w-[50%] lg:w-[100%]">
                <a href="https://t.me/Ulaprize_bot">
                    <button
                        className={`bg-[#C3372E] hover:bg-[#E0473F] active:bg-[#C3372E] p-4 xs:p-6 xs:text-[40px] text-left text-2xl w-full h-full  rounded-2xl object-cover  flex flex-col justify-between`}            >
                        <img src={img} alt="no image" className="ml-auto" />
                        <span className="mt-auto">{gift}</span>
                    </button>
                </a>

            </div>

        </div>

    );
};

export default Gift;